import {  observer } from "mobx-react";
import { translateKey as t } from "../../../locales/translation";
import { OFTableController } from "../OFTableController";

import { Spin } from "antd";

const RenderLoader = observer(({ ofTableController }: { ofTableController: OFTableController }) => {
  const { customLoader, loadingTable } = ofTableController;

  if (loadingTable) {
    if (customLoader) {
      return <div className="tableLoader">{customLoader}</div>;
    }

    return <Spin size="large" className="tableLoader" tip={t("lblLoadingData", "Loading Data...")} />;
  }

  return null;
});

export { RenderLoader };
